// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"c4-z","displaySixCardTiles":"d4-z"};